var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 14,
    viewBox: "0 0 10 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 0.5C4.375 0.5 3.79167 0.661458 3.25 0.984375C2.71875 1.29688 2.29167 1.72396 1.96875 2.26562C1.65625 2.79688 1.5 3.375 1.5 4V5.5H0V13.5H10V5.5H8.5V4C8.5 3.375 8.33854 2.79688 8.01562 2.26562C7.70312 1.72396 7.27604 1.29688 6.73438 0.984375C6.20312 0.661458 5.625 0.5 5 0.5ZM5 1.5C5.44792 1.5 5.86458 1.61458 6.25 1.84375C6.63542 2.0625 6.9375 2.36458 7.15625 2.75C7.38542 3.13542 7.5 3.55208 7.5 4V5.5H2.5V4C2.5 3.55208 2.60938 3.13542 2.82812 2.75C3.05729 2.36458 3.36458 2.0625 3.75 1.84375C4.13542 1.61458 4.55208 1.5 5 1.5ZM1 6.5H9V12.5H1V6.5Z",
    fill: "#089BAB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.81b7997a6d267d6c4effb67d51f29ff8.svg";
export { ForwardRef as ReactComponent };